import { PrivilegeArea } from '@dmonitor/shared/dto';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl:"http://localhost/myapp/api",
  //apiUrl:"http://gammadev.erise.hu/api",
  apiKey:"apikey",
  token : "",
  theme:"gamma",
  appVersion: require('../../package.json').version,
  privilegeAreaIds:{
    site_area:PrivilegeArea.SITE,
    county_area:PrivilegeArea.COUNTY,
    company_area:PrivilegeArea.COMPANY,
    equipment_area:PrivilegeArea.EQUIPMENT
  }  
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
